import type { ThemeTypes } from "~/types/themeTypes/theme-type";

const OniTheme: ThemeTypes = {
  name: "OniTheme",
  dark: true,
  variables: {
    "border-color": "#332833",
    "carousel-control-size": 10,
    "background-color": "#1E161E",
  },
  colors: {
        sidebarItemBg: "#2F222C",
        sidebarItemHoverBg: "#452B3B",
        sidebarItemActiveBg: "#623249",
        sidebarHeadingBg: "#49305E",

    primary: "#b271de",
    secondary: "#0fd4f5",
    info: "#403e89",
    success: "#25e092",
    accent: "#FFAB91",
    warning: "#eaae00d1",
    error: "#b7508c",
    muted: "#9e729e",
    lightprimary: "#853087",
    lightsecondary: "#08788f",
    lightsuccess: "#0a7d66",
    lighterror: "#b23434",
    lightwarning: "#b3770d",
    textPrimary: "#eaeaea",
    textSecondary: "#b3a3b3",
    borderColor: "#2a1e2a",
    inputBorder: "#443944",
    containerBg: "#1E161E",
    hoverColor: "#2f242f",
    surface: "#1B1723",
    "on-surface-variant": "#1c141c",
    // grey100: '#2a1e2a',
    // grey200: '#3b2e3b'
  },
};

export { OniTheme };
